export default function AndroidSunny() {
  return (
    <div
      className="ion-icon-android-sunny"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g id="Icon_27_">
	<g>
		<path d="M256,160c25.499,0,49.567,10.025,67.771,28.229C341.975,206.433,352,230.501,352,256s-10.025,49.567-28.229,67.771
			C305.567,341.975,281.499,352,256,352s-49.567-10.025-67.771-28.229C170.025,305.567,160,281.499,160,256
			s10.025-49.567,28.229-67.771C206.433,170.025,230.501,160,256,160 M277.333,32h-42.666v64h42.666V32L277.333,32z M406.396,75.729
			L368,114.135L397.864,144l38.406-38.396L406.396,75.729L406.396,75.729z M105.604,75.729l-29.875,29.875L114.136,144L144,114.135
			L105.604,75.729L105.604,75.729z M256,128c-70.396,0-128,57.604-128,128s57.604,128,128,128s128-57.604,128-128
			S326.396,128,256,128L256,128z M480,234.666h-64v42.668h64V234.666L480,234.666z M96,234.666H32v42.668h64V234.666L96,234.666z
			 M397.864,368L368,397.865l38.396,38.406l29.875-29.875L397.864,368L397.864,368z M114.136,368l-38.406,38.396l29.875,29.875
			L144,397.865L114.136,368L114.136,368z M277.333,416h-42.666v64c6.396,0,42.666,0,42.666,0V416L277.333,416z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
